import classNames from "classnames";

import { Container } from "@jti/core-components/components/Container";

import type { HealthBannerProps } from "./HealthBanner";
import { HealthBanner } from "./HealthBanner";

import styles from "./HealthBanner.module.scss";

export const FooterHealthBanner = (healthBannerProps: HealthBannerProps) => {
  if (!healthBannerProps.content) {
    return null;
  }
  return (
    <>
      {healthBannerProps.variant === "default" ? (
        <Container
          className={classNames({
            [styles.bannerDefaultWrapper]: healthBannerProps.variant === "default",
          })}
        >
          <HealthBanner {...healthBannerProps} />
        </Container>
      ) : (
        <HealthBanner {...healthBannerProps} />
      )}
    </>
  );
};
